import Text from '@/shared-components/text/components/Text';

import RatingBarDisplayer from './RatingBarDisplayer';
import RatingBarWithoutMyRating from './RatingBarWithoutMyRating';

import './styles/ArtworkRatingDisplayer.css';

export default function ArtworkRatingDisplayer({ className = "", category, username, userRating, myRating=null }) {
  
  return (
    <>
      <div className={`artwork-rating-displayer__container ${className}`}>
        <Text className="artwork-rating-displayer__category font-size-small" paragraph>
          {category}
        </Text>

        { myRating || myRating=== 0 ? (
          <RatingBarDisplayer
            username={username}
            userRating={userRating}
            myRating={myRating}
          />
        ) : <RatingBarWithoutMyRating
          username={username}
          userRating={userRating}
        />}
      </div>
    </>
  );
}
